"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadStatusCodeHook = void 0;
var shared_1 = require("@cian/peperrors/shared");
var BadStatusCodeHook = /** @class */ (function () {
    function BadStatusCodeHook(params) {
        this.assertStatusCode = params.context.assertStatusCode;
        this.mcsName = params.context.requestedServerName;
        this.requestConfig = params.requestConfig;
    }
    BadStatusCodeHook.prototype.onRequest = function () { };
    BadStatusCodeHook.prototype.onResponse = function (_a) {
        var responseStatusCode = _a.responseStatusCode;
        if (!this.assertStatusCode(responseStatusCode)) {
            throw new shared_1.HttpBadStatusCodeError("Microservice ".concat(this.mcsName, " api ").concat(this.requestConfig.url.origin).concat(this.requestConfig.url.pathname, " answers with not allowed status code: ").concat(responseStatusCode), responseStatusCode, "http-api.BadStatusCode.".concat(this.mcsName));
        }
    };
    BadStatusCodeHook.prototype.onError = function () { };
    return BadStatusCodeHook;
}());
exports.BadStatusCodeHook = BadStatusCodeHook;
//# sourceMappingURL=BadStatusCodeHook.js.map